import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import BgGradient from '../../../static/images/bggradient.webp'
import UniPassBlack from '../../../static/images/unipassBlack.webp'
import UniPassWhite from '../../../static/images/unipassWhite.webp'
import { ProductCard } from '../products/components/ProductCard'
import TrustNetAI from '../../../static/images/TrustNetAI.webp'
import TrustNetAIBlack from '../../../static/images/TrustNetAIBlack.webp'
import VisionAnalytics from '../../../static/images/VisionAnalytics.webp'
import VisionAnalyticsBlack from '../../../static/images/VisionAnalyticsBlack.webp'
import AnimalInsightsWhite from '../../../static/images/animalinsight.webp'
import AnimalInsightsBlack from '../../../static/images/animalinsightsBlack.webp'

export function Investment() {
    const location = useLocation()
    const { t } = useTranslation()
    const navigate = useNavigate()

    useEffect(() => {
        document.documentElement.style.scrollBehavior = 'smooth'
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }, [location])

    const investmentData = [
        {
            index: '1',
            whiteImg: AnimalInsightsWhite,
            blackImg: AnimalInsightsBlack,
            title: 'Animal Insights',
            text: t('landing.cards.animalinsights.description'),
        },
        {
            index: '2',
            whiteImg: VisionAnalytics,
            blackImg: VisionAnalyticsBlack,
            title: 'Vision Analytics',
            text: t('landing.cards.visionAnalytics.description'),
        },
        {
            index: '3',
            whiteImg: UniPassBlack,
            blackImg: UniPassWhite,
            title: 'UniPass',
            text: t('landing.cards.uniPass.description'),
            android: 'https://play.google.com/store/apps/details?id=uz.realsoft.ai.unipass&pcampaignid=web_share',
        },
        {
            index: '4',
            whiteImg: TrustNetAI,
            blackImg: TrustNetAIBlack,
            title: 'TrustNet AI',
            text: t('landing.cards.mlHub.description'),
        },
    ]

    return (
        <div className="w-full flex flex-col lg:max-w-[1440px]
            pb-[24px] lg:m-auto px-[24px] lg:px-[20px] gap-[100px]"
        >
            <section style={{ backgroundImage: `url(${BgGradient})` }}>
                <div className="flex flex-col pt-[38px] items-center pb-[20px] gap-[15px]">
                    <span className="text-[28px] font-[300] text-[#262626] dark:text-white">
                        {t('landing.investment.title')}
                    </span>
                    <div className="flex items-center">
                        <span
                            onClick={() => navigate('/')}
                            className="text-[14px] cursor-pointer font-[300] dark:text-white text-[#262626]"
                        >
                            {t('landing.investment.breadcrumb.home')}
                            /
                        </span>
                        <span className="text-[14px] cursor-pointer font-normal dark:text-white text-[#262626]">
                            {t('landing.investment.breadcrumb.current')}
                        </span>
                    </div>
                </div>
            </section>

            <section>
                <div className="flex flex-col lg:px-[24px] items-start mb-[91px] gap-[10px]">
                    <span className="text-[12px] lg:text-[16px] font-normal text-[#0068B5] dark:text-white">
                        {t('landing.main.cards.title')}
                    </span>
                    <span className="text-[31px] font-[300] text-[#262626] dark:text-white">
                        {t('landing.main.cards.subtitle')}
                    </span>
                </div>
                <div className="flex w-[100%] lg:mb-[110px] md:mb-[57px]
                    lg:px-[24px] flex-col items-center sm:gap-[100px] md:gap-[100px] lg:gap-[120px]"
                >
                    {investmentData.map((item) => (
                        <ProductCard
                            key={item.index}
                            whiteImg={item.whiteImg}
                            blackImg={item.blackImg}
                            index={item.index}
                            title={item.title}
                            text={item.text}
                            universalImg={item.universalImg}
                            android={item.android}
                            ios={item.ios}
                        />
                    ))}
                </div>
            </section>
        </div>
    )
}
